import './manifest.json';
import '../sass/main.scss';
import './resources/Images';
import './resources/Icones';

import React from 'react';
import {createRoot} from 'react-dom/client';
import 'bootstrap';

import Main from './componentes/Main';
// const Main = lazy(() => import(/* webpackChunkName: "main" */  './componentes/Main'));

const basePath = document.querySelector('body')
    .dataset.context;

(async (): Promise<void> => {
    if (!isIosOrMacOs())
        registerSW();
    const root = createRoot(document.querySelector<HTMLDivElement>('#app'));
    root.render(<Main/>);
})()
    .then(() => null)
    .catch(err => alert(err));

function registerSW(): void {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            const swUrl = `${basePath}sw.min.js?noCache=${Date.now()}`;
            try {
                await navigator.serviceWorker.register(swUrl);
                console.log('SW registrado.');
                window.addEventListener('beforeinstallprompt', (e) => {
                    e.preventDefault();
                    const deferredPrompt: any = e;
                    deferredPrompt.prompt();
                    deferredPrompt.userChoice.then((choiceResult: any) => {
                        if (choiceResult.outcome === 'accepted') {
                            console.log('User accepted the A2HS prompt');
                        } else {
                            console.log('User dismissed the A2HS prompt');
                        }
                    });
                });
            } catch (err) {
                console.log('SW não registrado.', err);
            }
        });
    }
}

function isIosOrMacOs(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
}